import type { MaintenanceRequestReceivableItemViewRow } from '@/services/maintenance';

const normalizeText = (value: unknown): string => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
};

const buildGroupKey = (row: MaintenanceRequestReceivableItemViewRow): string =>
  [
    row.maintenance_request_id,
    row.catalog_id ?? 'no-catalog',
    normalizeText(row.asset_name),
    normalizeText(row.lin),
    normalizeText(row.nsn),
    normalizeText(row.document_number),
  ].join('|');

export const groupMaintenanceReceivableItems = (
  rows: MaintenanceRequestReceivableItemViewRow[],
): MaintenanceRequestReceivableItemViewRow[] => {
  const grouped = new Map<string, MaintenanceRequestReceivableItemViewRow>();

  for (const row of rows) {
    const key = buildGroupKey(row);
    const existing = grouped.get(key);

    if (!existing) {
      grouped.set(key, {
        ...row,
        id: key,
        stock_quantity: Number.isFinite(row.stock_quantity)
          ? row.stock_quantity
          : row.asset_ids.length,
        asset_ids: [...row.asset_ids],
      });
      continue;
    }

    existing.stock_quantity += Number.isFinite(row.stock_quantity)
      ? row.stock_quantity
      : row.asset_ids.length;
    existing.asset_ids.push(...row.asset_ids);
  }

  return Array.from(grouped.values()).map((row) => ({
    ...row,
    asset_ids: Array.from(new Set(row.asset_ids)),
  }));
};
